import React, { Component } from 'react';
import DataFetcher from '../utils/DataFetcher';
import DeviceRevenuePage from '../components/DeviceRevenuePage';

class DeviceRevenueOfDelegate extends Component {
  constructor(props) {
    super(props)
    this.siteId = decodeURIComponent(this.props.match.params.siteId)
    this.delegateId = decodeURIComponent(this.props.match.params.delegateId)
  }

  render() {
    const pageProps = {
      fetchSites: (params, callback) => {
        DataFetcher.delegateSites(
          {
            ...params,
            delegateId: this.delegateId
          }, 
          {
            success: callback
          }
        )
      },
      fetchRevenue: (params, callback) => {
        DataFetcher.delegateDeviceRevenue(
          {
            ...params,
            delegateId: this.delegateId,
          }, 
          {
            success: callback
          }
        )
      },
      fetchDeviceTypes: (params, callback) => {
        DataFetcher.deviceTypes(
          {
            ...params,
            delegateId: this.delegateId,
          }, 
          {
            success: callback
          }
        )
      },
      defaultSiteId: this.siteId
    }

    return <DeviceRevenuePage {...pageProps}/>
  }
}

export default DeviceRevenueOfDelegate;


// WEBPACK FOOTER //
// ./src/modules/DeviceRevenueOfDelegate.js